module.exports = __webpack_public_path__ + "img/crewpages_logo_icon_white.6bef718d.svg";